// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://xrqrzrsuewjniognkzya.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InhycXJ6cnN1ZXdqbmlvZ25renlhIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTE0MTc5NTIsImV4cCI6MjA2Njk5Mzk1Mn0.PU8e_slWIxIGnhzOOij14RGSwLatNuWY499xPxDoLg4";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});